webpackJsonp([129339665448059],{

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ExamplePage = __webpack_require__(6);
	
	var _ExamplePage2 = _interopRequireDefault(_ExamplePage);
	
	var _CodeSample = __webpack_require__(5);
	
	var _CodeSample2 = _interopRequireDefault(_CodeSample);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _ExamplePage2.default,
	    { title: 'Select a range of days' },
	    _react2.default.createElement(
	      'p',
	      null,
	      'This example shows a possible implementation for a component selecting a range of days.'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'Use ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'selectedDays=',
	          '{{ from, to }}'
	        ),
	        ' to display a range of days as selected'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Use the provided ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'addDayToRange'
	        ),
	        ' utility to add or remove days to the range when the user clicks/taps on them'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Add ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'start'
	        ),
	        ' and ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'end'
	        ),
	        ' modifiers to style the first and last day in a different way.'
	      )
	    ),
	    _react2.default.createElement(_CodeSample2.default, { vertical: true, name: 'examples/selected-range' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-examples-selected-range-js-3de33de12e4c6250f66e.js